export enum DispatcherOrderStatusesEnum {
    'not_assigned' = 'Не назначен',
    'assigned_to_courier' = 'Назначен на курьера',
    'taken' = 'Забран курьером',
    'cargo_handling' = 'Отгружено на склад',
    'delivered' = 'Доставлен',
    'receiver_cancelled' = 'Отмена получателем',
    'date_changed' = 'Смена даты',
    'pickup' = 'Самовывоз',
    'cargo_returned' = 'Возврат груза',
    'receiver_missing' = 'Не найден получатель',
    'not_delivered' = 'Не доставлен',
    'delivering' = 'Доставляется',
}

export enum DispatcherSubmitOrdersTypesEnum {
    'onsector' = 'onsector',
    'ondispatchersector' = 'ondispatchersector',
}

export enum DISPATCHER_EVENTS {
    'DISPATCHER_MAP_READY' = 'DISPATCHER_MAP_READY',
    // edit
    'DISPATCHER_START_EDIT_SECTOR' = 'DISPATCHER_START_EDIT_SECTOR',
    'DISPATCHER_COMPLETE_EDIT_SECTOR' = 'DISPATCHER_COMPLETE_EDIT_SECTOR',
    'DISPATCHER_STOP_EDIT_SECTOR' = 'DISPATCHER_STOP_EDIT_SECTOR',
    // add
    'DISPATCHER_START_ADD_SECTOR' = 'DISPATCHER_START_ADD_SECTOR',
    'DISPATCHER_COMPLETE_ADD_SECTOR' = 'DISPATCHER_COMPLETE_ADD_SECTOR',
    'DISPATCHER_STOP_ADD_SECTOR' = 'DISPATCHER_STOP_ADD_SECTOR',
    // without address
    'DISPATCHER_SAVE_ADDRESS' = 'DISPATCHER_SAVE_ADDRESS',
}
